// extracted by mini-css-extract-plugin
export default {"hoverTr":"Department_hoverTr__dspof"};